module.exports = {
      id: "textsms-usage",
      viewBox: "0 0 28.57 28.57",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#textsms",
      toString: function () {
        return this.url;
      }
    }